import types from '../types';
import { LISTING_FIRST_PAGE } from '../../FilteredListing/constants';
import {
    getSearchValueFromURL,
    getCurrentPageFromURL
} from '../../FilteredListing/utils';

import { getFiltersInitialStateFromURL } from '.';

/**
 * @typedef Props
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {string} url
 * @property {types.Pagination} pagination
 */

/**
 * @typedef Output
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {Array} items
 * @property {string} searchValue
 * @property {types.Pagination} pagination
 * @property {boolean} isLoading
 * @property {boolean} isLoadingMore
 */

/**
 * @param {Props} initialData
 * @returns {Output}
 */
const getInitialState = initialData => {
    const { url } = initialData;

    const filters = getFiltersInitialStateFromURL(initialData.filters, url);

    const pagination = {
        ...initialData.pagination,
        currentPage: getCurrentPageFromURL(url) || LISTING_FIRST_PAGE
    };

    const searchValue = getSearchValueFromURL(url);

    return {
        items: [],
        filters,
        searchValue,
        pagination,
        isLoading: true,
        isLoadingMore: false
    };
};

export default getInitialState;
